import {
    Activity,
    AlertTriangle,
    Bot,
    FileCheck2,
    FileText,
    LayoutGrid,
    MessageSquare,
    Scale,
    ShieldCheck,
    Sparkles,
    Users,
    Zap,
    FolderOpen,
    MessageCircle,
} from "lucide-react";

export const TABS = [
    {
        id: "ozet",
        label: "Komuta Merkezi",
        icon: LayoutGrid,
        description: "Günlük öncelikler, KPI'lar ve hızlı işlemler tek ekranda.",
    },
    {
        id: "onay",
        label: "Evrak Onayı",
        icon: FileCheck2,
        description: "Müvekkil portalından yüklenen belgeleri inceleyin, onaylayın veya reddedin.",
    },
    {
        id: "mesaj",
        label: "Mesajlar",
        icon: MessageSquare,
        description: "Dosya bazlı müvekkil yazışmalarına yanıt verin.",
    },
    {
        id: "eksik",
        label: "Eksik Evrak",
        icon: AlertTriangle,
        description: "7'li zorunlu evrak seti tamamlanmamış dosyaları takip edin.",
    },
    {
        id: "aktivite",
        label: "Canlı Akış",
        icon: Activity,
        description: "Portal evrak, durum ve ödeme bildirimlerinin kronolojik akışı.",
    },
    {
        id: "akil",
        label: "Portal Akıl",
        icon: Bot,
        description: "Müvekkil portalındaki AI asistanını yönetin ve soruları izleyin.",
    },
    {
        id: "tahkim",
        label: "Tahkim Akıl",
        icon: Scale,
        description: "STK checklist, dilekçe paketi, savunma brifingi ve red analizi.",
    },
    {
        id: "rehber",
        label: "İş Rehberi",
        icon: Sparkles,
        description: "Operasyon akışı, kısayollar ve modül açıklamaları.",
    },
];

export const WORKFLOW_STEPS = [
    {
        step: 1,
        title: "Portal evrakı gelir",
        detail: "Müvekkil belge yükler → Onay kuyruğuna düşer.",
        tab: "onay",
    },
    {
        step: 2,
        title: "Onay / red + mesaj",
        detail: "Evrakı onaylayın veya gerekçeli reddedin; dosyaya yanıt yazın.",
        tab: "mesaj",
    },
    {
        step: 3,
        title: "Eksik evrak takibi",
        detail: "Zorunlu belgeler tamamlanana kadar dosyayı izleyin.",
        tab: "eksik",
    },
    {
        step: 4,
        title: "Tahkim hazırlığı",
        detail: "Checklist, dilekçe önizleme ve STK başvuru paketi oluşturun.",
        tab: "tahkim",
    },
];

export const QUICK_LINKS = [
    { to: "/e/muvekkiller", label: "Müvekkiller", icon: Users, hint: "Kayıt & iletişim" },
    { to: "/e/sigorta-dosyalari", label: "Sigorta Dosyaları", icon: FolderOpen, hint: "Dosya kartları" },
    { to: "/e/evraklar?portal_kaynak=1", label: "Portal Evrakları", icon: FileText, hint: "Tüm yüklemeler" },
    { to: "/yeni/whatsapp-merkezi", label: "WhatsApp Merkezi", icon: MessageCircle, hint: "Mesaj & otomasyon" },
    { to: "/yeni/tahkim-merkezi", label: "Tahkim Merkezi", icon: Scale, hint: "Kanban & operasyon" },
    { to: "/e/tahkim-dosyalari", label: "Tahkim Veri Girişi", icon: Scale, hint: "STK kayıtları" },
];

export const MODULE_GUIDES = [
    {
        id: "onay",
        title: "Evrak Onay Kuyruğu",
        icon: FileCheck2,
        bullets: [
            "Yalnızca müvekkil portalından gelen evraklar listelenir.",
            "Onay sonrası evrak dosyada aktif sayılır; red gerekçesi müvekkile görünür.",
            "Önizleme ile PDF/görsel kontrol edin, toplu işlem için filtreyi kullanın.",
        ],
    },
    {
        id: "mesaj",
        title: "Dosya Mesajları",
        icon: MessageSquare,
        bullets: [
            "Yanıt bekleyen: son mesaj müvekkilden gelmiş dosyalar.",
            "Yanıtlar DosyaYorumu olarak kaydedilir; müvekkil portalında görünür.",
            "WhatsApp ile paralel iletişim için WhatsApp Merkezi'ne geçin.",
        ],
    },
    {
        id: "eksik",
        title: "Eksik Evrak Modülü",
        icon: AlertTriangle,
        bullets: [
            "MBS 7'li zorunlu evrak setine göre hesaplanır.",
            "Tahkim geçişi ve sigorta başvurusu için tamamlanması gerekir.",
            "Dosyaya tıklayarak eksik belgeleri tek tek yükletebilirsiniz.",
        ],
    },
    {
        id: "tahkim",
        title: "Tahkim Akıl",
        icon: Scale,
        bullets: [
            "Sigorta mail tarihi + 15 gün → tahkim hedef tarihi otomatik hesaplanır.",
            "Önizlemeyi güncelle: dosya verisi değişince metinleri yenileyin.",
            "Paket: Word dilekçe + sistem evrakları ZIP olarak üretilir.",
        ],
    },
    {
        id: "akil",
        title: "Portal Akıl",
        icon: Bot,
        bullets: [
            "Müvekkil /panel/dashboard/ ekranında dosya durumu sorularını yanıtlar.",
            "Kapalıyken müvekkil AI butonu devre dışı kalır.",
            "Sorular loglanır; otomatik model eğitimi yapılmaz.",
        ],
    },
];

export const BRAND = {
    gold: "#D4AF37",
    burgundy: "#8b1f2f",
};
